/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// import ReactDOM from "react-dom"; // used to grab the table element specifically
// material
import Link from 'material/ctas/link/link_container';
import Icon from 'material/graphic/icon/icon';
import Group from 'material/group/group';
import Title from 'material/copy/title/title';
import NoDataView from 'material/nodataview/nodataview';
import Loader from 'material/loader/loader';
import ExportExcel from 'material/ctas/exportexcel/exportexcel_container';
// grids
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
// pagination
import Pagination from 'material/pagination/pagination';
// tables
import TableHeader from 'material/table/thead/thead';
import TableBody from 'material/table/tbody/tbody';
// import TableFooter from 'material/table/tfoot/tfoot';
import TableRow from 'material/table/row/row';
import TableColumnHead from 'material/table/head/head';
import TableColumn from 'material/table/column/column';
// utils
import { generateClasses } from 'utils/generators';
// styles
import injectSheet from 'react-jss';
import styles from 'material/table/table_styles';



/* ========== ~~~~~~~~~~ TABLE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Table extends Component {
	constructor(props) {
		super(props);
		this.rowsPerPage = this.props.rowsPerPage === 'general' ? 5 : this.props.rowsPerPage; // set general row amount for tables
		this.totalRows = this.props.data.length;
		this.state = { currentIndex: this.rowsPerPage };
	}
	componentDidUpdate(prevProps){
		if(prevProps.data.length !== this.props.data.length){
			this.setState({currentIndex: this.rowsPerPage})
		}
	}
	loadTable = () => {
		return this.props.loading ? <div className={'loading'} >loading... <Loader name={'loader'}/></div> : this.displayTable();
	};
	displayTable = () => {
		switch (!!this.props.data.length) {
			case true:
				return <div className={`tableview`}>
							<table className={`table`}>
			                    <TableHeader>
			                    	{this.props.specialHeads ? this.createSpecialHeads() : null}
			                        <TableRow>
			                            {this.createColumnHeads()}
			                        </TableRow>
			                    </TableHeader>
			                    <TableBody>
			                    	{this.props.specialRow && this.props.specialRowPosition === 'top' ? this.createSpecialRow() : null}
			                        {this.createRows(this.getSlicedRowData(this.state.currentIndex))}
			                        {this.props.specialRow && this.props.specialRowPosition === 'bottom' ? this.createSpecialRow() : null}
			                    </TableBody>
		                	</table>
		            	</div>
	            ;
			case false:
			default:
				return <NoDataView />
        }
	}
	initialDataSet = () => {
		return this.hasPagination() ? this.props.data.slice(0, this.rowsPerPage) : this.props.data;
	}
	hasPagination = () => {
		return this.rowsPerPage < 1 || this.rowsPerPage === null || this.rowsPerPage === undefined ? false : true;
	}
	hasHeader = () => {
		return this.props.showTitle || this.props.exportData ? true : false;
	}
	hasMessage = () => {
		return this.props.message ? true : false;
	}
	hasFooter = () => {
		return this.props.moreDetails ? true : false;
	}
	handlePagination = (e) => {
		this.setState({ currentIndex: this.getNewIndex(e) }); // reset current row markup based on selected pagination control (show next/prev x number of records)
	}
	getNewIndex = (e) => {
		return e === 'next' ? (this.state.currentIndex + this.rowsPerPage) : (this.state.currentIndex - this.rowsPerPage);
	}
	getSlicedRowData = (currentIndex) => {
		const newIndex = currentIndex;
		const startIndex = newIndex - this.rowsPerPage;
		return this.props.rowsPerPage ? this.props.data.slice(startIndex, newIndex) : this.props.data;
	}
	handleAdditionalProps = (num) => {
		let additionalProps = {};
		if ((this.props.type === 'fixed-column') && (num <= 1)) {
			if (num === 0) {
				additionalProps.isFixedCol = true;
				additionalProps.fixedColWidth = this.props.fixedColWidth;
			}
		}
		return additionalProps;
	}
	createColumnHeads = () => {
		return Object.values(this.props.columnHeads).map((head, index) => {
			let additionalProps = this.handleAdditionalProps(index);
			return <TableColumnHead key={index} {...additionalProps}>{head}</TableColumnHead>
		});
	}
	createRows = (rowData) => {
		return rowData.map((row, index) => {
			return(
				<TableRow key={index} handleClick={row.handleRowClick} processing={row.processing} disabled={row.disabled}>
					{Object.entries(this.sortColumns(row)).map((column, index) => {
						let additionalProps = this.handleAdditionalProps(index);
						return (<TableColumn key={index} {...additionalProps}>{column[1]}</TableColumn>)
					})}
				</TableRow>
			)}
		);
	}
	createSpecialHeads = () => {
		// used for group heads of report preview page (data formatted to deal with colspans)
		return(
			<TableRow klass={`specialhead`}>
				{this.props.specialHeads.map((col, index) => {
					return (<TableColumnHead key={index} colspan={col.colspan}>{col.colcontent}</TableColumnHead>)
				})}
			</TableRow>
		)
	}
	createSpecialRow = () => {
		// used for totals of report preview page (data formatted to deal with colspans)
		return(
			<TableRow klass={`specialrow`}>
				{this.props.specialRow.map((col, index) => {
					if (col.colspan > 0) { 
						return (<TableColumn key={index} colspan={col.colspan}>{col.colcontent}</TableColumn>)
					} else {
						return Object.entries(col.colcontent).map((content, nIndex) => {
							return (<TableColumn key={nIndex}>{content[1]}</TableColumn>)
						})
					}
				})}
			</TableRow>
		)
	}
	sortColumns = (row) => {
		// ensure the data we display is in the order of the "columnHeads" prop object we passed through
		// modifying the order of the "columnHeads" prop will affect the display
		if (row !== undefined) {
			let sortedData = [];
			Object.keys(this.props.columnHeads).forEach(head => {
				Object.entries(row).forEach(item => {
					if (item[0] === head) {
						sortedData.push(item[1]);
					}
				})
			});
			return sortedData;
		}
	}
	displayPagination = () => {
		return !this.hasPagination() || (this.rowsPerPage >= this.props.data.length) ? null :
			<Pagination 
				handlePrevious={this.handlePagination} 
				handleNext={this.handlePagination} 
				itemsPerPage={this.rowsPerPage}
				totalItems={this.props.data.length}
				currentIndex={this.state.currentIndex}
			/>
		;
	}
	displayTableHeader = () => {
		return !this.hasHeader() ? null : 
			<Grid name={`tableheader`}>
				<GridSet direction={`horizontal`}>
					<GridItem name={`headertitle`}>{!this.props.showTitle ? null : <Title size={`small`}><h3>Table View</h3></Title>}</GridItem>
		        	<GridItem name={`headerctas`}>
		        		{this.props.exportData && <ExportExcel export={{data: this.props.data, fileName: this.props.exportData.fileName, excludedColumns: this.props.exportData.excludedColumns}} />}
		        		{this.props.exportAll && <ExportExcel exportAll={this.props.exportAll} />}
		        	</GridItem>
			    </GridSet>
		    </Grid>
		;
	}
	displayTableMessage = () => {
		return !this.hasMessage() ? null : 
			<Group name={`tablemessage`}>
				{this.props.message}
		    </Group>
		;
	}
	displayTableFooter = () => {
		return !this.hasFooter() ? null :
			<Group name={`tablefooter`}>
				<Link type={`internal`} text={`View Full List`} color={`primary`} action={`dashboard/analytics/detail/${this.props.dataType}`} icon={<Icon name={`table`} />} iconRight />
			</Group>
        ;
	}
	render() {
        this.rowsPerPage = this.props.rowsPerPage === 'general' ? 5 : this.props.rowsPerPage;
		return (
			<div className={`tablewrapper ${generateClasses(this.props)} ${!this.props.variant ? `variant-standard` : null} ${this.props.paginationLocation ? `paginationLocation-${this.props.paginationLocation}` : ''} hasHeader-${this.hasHeader()} hasMessage-${this.hasMessage()} hasFooter-${this.hasFooter()} ${this.props.classes.tablewrapper}`}>
				{this.displayPagination()}
				{this.displayTableHeader()}
				{this.loadTable()}
				{this.displayTableMessage()}
		        {this.displayTableFooter()}
		    </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Table);